import { render, staticRenderFns } from "./BackupSchedule.vue?vue&type=template&id=2135d2e0&"
import script from "./BackupSchedule.vue?vue&type=script&lang=js&"
export * from "./BackupSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BackupSchedule.vue?vue&type=style&index=0&id=2135d2e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports